/**
 * home js
 * js functions for the home page
 *
 */
(function ($) {
    SoyVay.homePageFunctions = (function () {
        function privateInit() {
            // get all promo modules, filter down to only modules without nested modules
            const promoModules = document.querySelectorAll('.promo-module:not(.parent)');

            // limit the rate at which a function can fire.
            // https://davidwalsh.name/javascript-debounce-function
            function debounce(func) {
                /* eslint-disable prefer-rest-params */
                const wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
                const immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

                let timeout;
                return function () {
                    const context = this;
                    const args = arguments;
                    const later = function later() {
                        timeout = null;
                        if (!immediate) func.apply(context, args);
                    };
                    const callNow = immediate && !timeout;
                    clearTimeout(timeout);
                    timeout = setTimeout(later, wait);
                    if (callNow) func.apply(context, args);
                };
            }

            // Determine if an element is in the visible viewport
            function isInViewport(element, offsetXIn, offsetYIn) {
                const offsetX = offsetXIn || 0;
                const offsetY = offsetYIn || 0;
                const area = element.getBoundingClientRect();
                const boundary = document.documentElement;
                return (
                    area.top >= 0 &&
                    area.left >= 0 &&
                    area.bottom <= (window.innerHeight || boundary.clientHeight) + offsetY &&
                    area.right <= (window.innerWidth || boundary.clientWidth) + offsetX
                );
            }

            // loop through each promo module and check where it's at
            function checkPromoVisibility(event) {
                promoModules.forEach((promoUnit) => {
                    if (isInViewport(promoUnit, 0, 0)) {
                        promoUnit.classList.add('activate-animation');
                        promoUnit.classList.remove('reverse-animation');
                    } else {
                        promoUnit.classList.remove('activate-animation');
                        promoUnit.classList.add('reverse-animation');
                    }
                });
            }

            // reset animation state classes
            function resetPromoModule() {
                $('.promo-module').removeClass('activate-animation reverse-animation');
            }

            // make a reference var for each experience type to help with unbinding
            const hoverExperience = function () {
                $('.promo-module:not(.parent)').hover(
                    function () {
                        $(this).addClass('activate-animation').removeClass('reverse-animation');
                    },
                    function () {
                        $(this).removeClass('activate-animation').addClass('reverse-animation');
                    }
                );
            };

            const scrollExperience = function () {
                debounce(checkPromoVisibility());
            };

            // user resizes window.
            // should get one set of rules for mobile, one set for desktop
            // kill desktop for mobile and vice versa
            $(window).on('load resize', (e) => {
                // cache current window width
                const windowWidth = $(window).width();

                // clear out any animation classes on promo modules
                resetPromoModule();

                if (windowWidth <= 768) {
                    // unbind any hover events that might be left over from a window resize
                    $('.promo-module:not(.parent)').off('mouseenter mouseleave');

                    // do the scroll experience
                    window.addEventListener('scroll', scrollExperience);
                } else {
                    // unbind scroll events that might be left over from a window resize
                    window.removeEventListener('scroll', scrollExperience);

                    // do the hover experience
                    hoverExperience();
                }
            });
        }
        return {
            init() {
                privateInit();
            },
        };
    })();

    // document ready
    $(document).ready(() => {
        SoyVay.homePageFunctions.init();
    });
})(jQuery);
